import greek_salad from '../../../assets/img/greek_salad.jpg';
import bruschetta from '../../../assets/img/bruschetta.jpg';
import lemon_dessert from '../../../assets/img/lemon_dessert.jpg';

export const specialsData = [
  {
    id: 'sp1',
    image: greek_salad,
    title: 'Greek Salad',
    price: 45.65,
    description:
      'The famous greek salad of crispy lettuce, peppers, olives and our Chicago style feta cheese, garnished with crunchy garlic and rosemary croutons.',
  },
  {
    id: 'sp2',
    image: bruschetta,
    title: 'Bruschetta',
    price: 5.99,
    description:
      'Our Bruschetta is made from grilled bread that has been smeared with garlic and seasoned with salt and olive oil.',
  },
  {
    id: 'sp3',
    image: lemon_dessert,
    title: 'Lemon Dessert',
    price: 5.0,
    description:
      'This comes straight from grandma’s recipe book, every last ingredient has been sourced and is as authentic as can be imagined.',
  },
];
